import { useDecision } from '@optimizely/react-sdk'
import useSWR from 'swr'

import { menuExperimentsFetcher } from '@library/api-menu-experience'

import { GOUSTO_ANYTIME_FLAG } from './useDeliverySettings'

const GOUSTO_ANYTIME_MENU_EXPERIMENT_KEY = 'gousto-anytime'
const VARIANT = 'variant'

export const useGoustoAnytimeMenuVariant = (): boolean => {
  const [decision] = useDecision(GOUSTO_ANYTIME_FLAG)
  const { data } = useSWR(
    decision.enabled ? 'gousto-anytime-menu-experiments' : null,
    menuExperimentsFetcher,
  )

  return data?.experiments[GOUSTO_ANYTIME_MENU_EXPERIMENT_KEY] === VARIANT
}
